import { Box, Flex, FlexProps } from '@cmpsr/components';
import { PropsWithChildren } from 'react';

export default function RisksCard(props: FlexProps) {
  return (
    <Flex
      flexDirection="column"
      bgColor="background-card"
      border="1px solid"
      borderColor="ui-element-divider"
      borderRadius="radii-3"
      {...props}
    >
      {props.children}
    </Flex>
  );
}

RisksCard.Header = ({ children, ...props }: PropsWithChildren & FlexProps) => (
  <Box
    borderBottom="1px solid"
    borderColor="ui-element-divider"
    py="spacer-6"
    px="spacer-6"
    textAlign="center"
    {...props}
  >
    {children}
  </Box>
);

RisksCard.Content = (props: FlexProps) => (
  <Flex py="spacer-4" px="spacer-6" gap="spacer-4" direction="column" {...props}>
    {props.children}
  </Flex>
);

RisksCard.Footer = ({ children }: PropsWithChildren) => (
  <Box
    backgroundColor="background-page"
    border="0"
    borderTop="1px solid"
    borderColor="ui-element-divider"
    borderBottomRadius="radii-3"
    py="spacer-4"
    px="spacer-6"
    textAlign="center"
  >
    {children}
  </Box>
);
